import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DataTable } from "./DashboardStyles";
import { formatIsoDateAsLocalTimezoneDate } from "./common";

interface AssignmentItem {
  lesson_link: string;
  lesson_title: string;
  completions: string;
  last_execution_activity_date_iso: string;
}

export const AssignmentsTab = ({
  assignments,
  navigate,
}: {
  assignments: AssignmentItem[];
  navigate: (string) => void;
}) => {
  const { t } = useTranslation();
  return assignments.length === 0 ? (
    <>
      <Row className="px-5">
        <Col>
          <div className="mt-5 text-center">
            {t("dashboard_assignments_no_students1")}
          </div>
          <div className="mt-3 text-center">
            {t("dashboard_assignments_no_students2")}
          </div>
          <div className="mt-3 text-center">
            {t("dashboard_assignments_no_students3")}
          </div>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs={8} md={6} lg={4} className="mx-auto">
          <img className="img-fluid" alt="" src={`${process.env.PUBLIC_URL}/assignments_kids.png`} />
        </Col>
      </Row>
    </>
  ) : (
    <DataTable>
      <thead>
        <tr>
          <th scope="col">{t("dashboard_assignments_column_title")}</th>
          <th scope="col">{t("dashboard_assignments_column_completions")}</th>
          <th scope="col">{t("dashboard_assignments_column_activity")}</th>
        </tr>
      </thead>
      <tbody>
        {assignments.map((a, index) => (
          <tr key={index}>
            <td>
              <a href={a.lesson_link} onClick={() => navigate(a.lesson_link)}>
                {a.lesson_title}
              </a>
            </td>
            <td>{a.completions}</td>
            <td>
              {a.last_execution_activity_date_iso
                ? formatIsoDateAsLocalTimezoneDate(
                    a.last_execution_activity_date_iso
                  )
                : "-"}
            </td>
          </tr>
        ))}
      </tbody>
    </DataTable>
  );
};
